// extracted by mini-css-extract-plugin
export var ScrollList = "s_C";
export var aniSpin = "s_d";
export var inner = "s_r";
export var shadowBottom = "s_F";
export var shadowTop = "s_D";